__turbopack_context__.v({
  "button": "secondary-module-scss-module__63tIYW__button" + " " + __turbopack_context__.i(693367)["block"],
  "complete": "secondary-module-scss-module__63tIYW__complete" + " " + __turbopack_context__.i(693367)["complete"],
  "medium": "secondary-module-scss-module__63tIYW__medium" + " " + __turbopack_context__.i(693367)["medium"],
  "playing": "secondary-module-scss-module__63tIYW__playing" + " " + __turbopack_context__.i(693367)["playing"],
  "small": "secondary-module-scss-module__63tIYW__small" + " " + __turbopack_context__.i(693367)["small"],
});
